import { Checkbox, Form, Input, Select, Space } from "antd";
import { FC } from "react";
import AppSelect from "./components/AppSelect";
import FieldsShownInLookupPicker from "./components/FieldsShownInLookupPicker";
import FieldMappings from "./components/FieldMappings";
import InitialFilterSetting from "./components/InitialFilterSetting";
import { ERRORS_MESSAGE } from "@lhd/constants";

type PropsType = {
  getFieldClassName?: (name: string) => string;
};

const LookupSetting: FC<PropsType> = ({ getFieldClassName }) => {
  return (
    <>
      <Form.Item
        label="フィールド名"
        name="name"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("name")}`}
      >
        <Input />
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_hide_name"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>フィールド名を表示しない</Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_required_field"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>必須項目にする</Checkbox>
      </Form.Item>
      <Space>
        <AppSelect />
        <Form.Item extra={<div />} label="キー フィルード">
          <Select style={{ width: 200 }} />
        </Form.Item>
      </Space>
      <FieldMappings />
      <FieldsShownInLookupPicker />
      <InitialFilterSetting />
    </>
  );
};

export default LookupSetting;
